// import React from 'react';
import styled from 'styled-components';

export default styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  display: none;
  @media all and (min-width: ${({ navBreakpoint }) => navBreakpoint}) {
    display: flex;
  }
`;
